import { DrillDownRequestTypes } from "../../../../../infrastructure/enums";

export const DRILLDOWN_TYPES_REQUIRING_SUBTYPE: DrillDownRequestTypes[] = [
  DrillDownRequestTypes.family_registration,
  DrillDownRequestTypes.anc,
  DrillDownRequestTypes.pnc,
  DrillDownRequestTypes.hbnc,
  DrillDownRequestTypes.eligible_couple_register,
  DrillDownRequestTypes.birth_register,
  DrillDownRequestTypes.child_immunization,
  DrillDownRequestTypes.death_register,
];